export const COUNTDOWN_TOGGLE = 'COUNTDOWN_TOGGLE';
export const COUNTDOWN_HISTORY_ADD = 'COUNTDOWN_HISTORY_ADD';
export const COUNTDOWN_HISTORY_REMOVE = 'COUNTDOWN_HISTORY_REMOVE';
